import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyBRKFOHlEaHTiXFoX--HtBipgXDxGzsH6A",
    authDomain: "wabbit-ai.firebaseapp.com",
    projectId: "wabbit-ai",
    storageBucket: "wabbit-ai.appspot.com",
    messagingSenderId: "411877296151",
    appId: "1:411877296151:web:ea3b9c4417f48020877452",
    measurementId: "G-Z8JGPSM4VG"
  };

// Initialize Firebase
const app = firebase.initializeApp(firebaseConfig);
// const analytics = firebase.getAnalytics(app);

// firebase.initializeApp(firebaseConfig);

export const auth = firebase.auth();
export const provider = new firebase.auth.GoogleAuthProvider();
export const firestore = firebase.firestore(); // Export this line if you're using Cloud Firestore